module.exports = __webpack_public_path__ + "media/images/details__prizeBox__season__first-04511167761e6d63c1dccb5a6d463fed.png";